import { render, staticRenderFns } from "./xomly.vue?vue&type=template&id=455474e6&"
import script from "./xomly.vue?vue&type=script&lang=js&"
export * from "./xomly.vue?vue&type=script&lang=js&"
import style0 from "./xomly.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports